import React, { useMemo, useEffect } from "react";
import { connect } from "react-redux";
import { Activity } from 'lucide-react';

export function MemUsageChart(memLoadData) {
    const percentage = useMemo(() => {
        if (!isNaN(memLoadData.used) && !isNaN(memLoadData.total) && memLoadData.total > 0) {
            return Number(memLoadData.used / memLoadData.total * 100).toFixed();
        } else {
            return 0;
        }
    }, [memLoadData.used, memLoadData.total]);

    useEffect(() => {
        const lineElement = document.getElementById('dynamicWidthV2');
        if (lineElement) {
            lineElement.style.width = percentage + "%";
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [memLoadData.used, memLoadData.total]);

    return (
        <div className="oct_sys-chart-card-v2">
            <div className="oct_sys-chart-header-v2 mb-4">
                <Activity className="oct_icon" />
                <h3>Memory Usage</h3>
            </div>

            <div className="oct_sys-mem-stats-list-v2">
                <div className="stat-row">
                    <span className="label">Total:</span>
                    <span className="value">{memLoadData.total} {isNaN(memLoadData.total) ? '' : 'Mb'}</span>
                </div>
                <div className="stat-row">
                    <span className="label">Free:</span>
                    <span className="value">{memLoadData.free} {isNaN(memLoadData.free) ? '' : 'Mb'}</span>
                </div>
                <div className="stat-row">
                    <span className="label">Used:</span>
                    <span className="value">{memLoadData.used} {isNaN(memLoadData.used) ? '' : 'Mb'}</span>
                </div>
                <div className="stat-row">
                    <span className="label">Buffers:</span>
                    <span className="value">{memLoadData.buffers} {isNaN(memLoadData.buffers) ? '' : 'Mb'}</span>
                </div>
                <div className="stat-row">
                    <span className="label">Cache:</span>
                    <span className="value">{memLoadData.cached} {isNaN(memLoadData.cached) ? '' : 'Mb'}</span>
                </div>
            </div>

            <div className="oct_sys-mem-progress-wrapper-v2">
                <div className="progress-header">
                    <span className="label">Usage</span>
                    <span className="value">{percentage}%</span>
                </div>
                <div className="progress-bg">
                    <div
                        id="dynamicWidthV2"
                        className="progress-fill"
                    ></div>
                </div>
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    const pageData = state.systemPage;
    const data = pageData.mem;
    return {
        total: isNaN(data.total) ? data.total : Number(data.total * 0.000001).toFixed(),
        free: isNaN(data.free) ? data.free : Number(data.free * 0.000001).toFixed(),
        used: isNaN(data.used) ? data.used : Number(data.used * 0.000001).toFixed(),
        buffers: isNaN(data.buffers) ? data.buffers : Number(data.buffers * 0.000001).toFixed(),
        cached: isNaN(data.cached) ? data.cached : Number(data.cached * 0.000001).toFixed(),
    }
}

export default connect(mapStateToProps)(MemUsageChart);